import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import TextAreaInput from "../UI/Input/TextAreaInput";
import Card from "@mui/material/Card";
import FileUploader from "../FileUploader";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const EditBrand = () => {
  const [rest, setRest] = useState([]);
  let history = useHistory();
  let { id } = useParams();
  const [cat, setCat] = useState({
    name: "",
    description: "",
    instagram_url: "",
    facebook_url: "",
    twitter_url: "",
    sort: "",
    people_served: "",
    events_hosted: "",
    opened_in: "",
    restro_id:"",
    title1: "",
    title2: "",
    title3: "",
    title4: "",
    subtitle1: "",
    subtitle2: "",
    subtitle3: "",
    subtitle4: "",
    address: "",
    featuresicon1: "",
    featuresicon2: "",
    featuresicon3: "",
    featuresicon4: "",
    logo: "",
    image: "",
    banner_image: "",
    banner_video: "",
    status: "",
    showLogo: "",
    showWebImage: "",
    showWebVideo: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileImage, setSelectedFileImage] = useState(null);
  const [selectedwebImage, setSelectedwebImage] = useState(null);
  const [selectedwebVideo, setSelectedwebVideo] = useState(null);
  const [selectedfeaturesicon1, setSelectedfeaturesicon1] = useState(null);
  const [selectedfeaturesicon2, setSelectedfeaturesicon2] = useState(null);
  const [selectedfeaturesicon3, setSelectedfeaturesicon3] = useState(null);
  const [selectedfeaturesicon4, setSelectedfeaturesicon4] = useState(null);
  const [showapp, setShowapp] = useState(0);
  const [showweb, setShowweb] = useState(0);
  const [loading, setloading] = useState(false);
  const {
    name,
    description,
    logo,
    image,
    banner_image,
    sort,
    opened_in,
    events_hosted,
    people_served,
    banner_video,
    featuresicon1,
    featuresicon2,
    featuresicon3,
    featuresicon4,
    instagram_url,
    twitter_url,
    facebook_url,
    website_url,
    title1,
    title2,
    title3,
    title4,
    subtitle1,
    subtitle2,
    subtitle3,
    subtitle4,
    address,
    status,
    restro_id,
  } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    //console.log(cat);
  };
  useEffect(() => {
    edit();
    getRestaurentsDropDown();
  }, []);
  //console.log(id)
  const edit = async () => {
    await axios.post(endpoints.editBrand, { id: id }).then((response) => {
      setCat({
        id: response.data.data.id,
        name: response.data.data.name,
        sort: response.data.data.sort,
        opened_in: response.data.data.opened_in,
        events_hosted: response.data.data.events_hosted,
        restro_id:response.data.data.restro_id,
        people_served: response.data.data.people_served,

        description: response.data.data.description,
        address: response.data.data.address,
        title1: response.data.data.title1,
        title2: response.data.data.title2,
        title3: response.data.data.title3,
        title4: response.data.data.title4,
        subtitle1: response.data.data.subtitle1,
        subtitle2: response.data.data.subtitle2,
        subtitle3: response.data.data.subtitle3,
        subtitle4: response.data.data.subtitle4,

        instagram_url:
          response.data.data.instagram_url != "null"
            ? response.data.data.instagram_url
            : "",
        facebook_url:
          response.data.data.facebook_url != "null"
            ? response.data.data.facebook_url
            : "",
        twitter_url:
          response.data.data.twitter_url != "null"
            ? response.data.data.twitter_url
            : "",
        website_url:
          response.data.data.website_url != "null"
            ? response.data.data.website_url
            : "",
        image: response.data.data.image,
        banner_image: response.data.data.banner_image,
        banner_video: response.data.data.banner_video,
        status: response.data.data.status,
        logo: response.data.data.logo,
        featuresicon1: response.data.data.featuresicon1,
        featuresicon2: response.data.data.featuresicon2,
        featuresicon3: response.data.data.featuresicon3,

        featuresicon4: response.data.data.featuresicon4,
      });
      //console.log(response.data.data.id,)
      setShowapp(response.data.data.show_app);
      setShowweb(response.data.data.show_web);
    });
  };
  const setStatus = async (e, type) => {
    if (e.target.checked) {
      var status = 1;
    } else {
      var status = 0;
    }
    if (type == "app") {
      setShowapp(status);
    } else {
      setShowweb(status);
    }
  };
  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("sort", sort);
    formData.append("opened_in", opened_in);
    formData.append("people_served", people_served);
    formData.append("events_hosted", events_hosted);
    formData.append("restro_id", restro_id);

    formData.append("description", description);
    formData.append("address", address);
    formData.append("instagram_url", instagram_url);
    formData.append("facebook_url", facebook_url);
    formData.append("twitter_url", twitter_url);
    formData.append("title1", title1);
    formData.append("title2", title2);
    formData.append("title3", title3);
    formData.append("title4", title4);
    formData.append("subtitle1", subtitle1);
    formData.append("subtitle2", subtitle2);
    formData.append("subtitle3", subtitle3);
    formData.append("subtitle4", subtitle4);
    formData.append("website_url", website_url);
    formData.append("logo", selectedFile);
    formData.append("image", selectedFileImage);
    formData.append("banner_image", selectedwebImage);
    formData.append("banner_video", selectedwebVideo);
    formData.append("featuresicon1", selectedfeaturesicon1);
    formData.append("featuresicon2", selectedfeaturesicon2);
    formData.append("featuresicon3", selectedfeaturesicon3);
    formData.append("featuresicon4", selectedfeaturesicon4);

    formData.append("status", status);
    formData.append("id", id);
    try {
      const response = await axios.post(endpoints.updateBrand, formData);
      setloading(false);
      history.goBack();

      if (response.data && response.data.status === true) {
        toast.success("Brand Updated Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during editing Brand:", error);
      setloading(false);

      toast.error("Error during editing Brand. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  const removeImageHandler = async (id, type) => {
    await axios
      .post(endpoints.deleteBrandImage, { id, type })
      .then((response) => {});
    window.location.reload();
  };

  const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
      setRest(response.data.data);
      //console.log(setRest)
    });
  };
  return (
    <div className="ui main">
      <h2>Edit Brand</h2>
      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              requiredInput="required"
              onChange={(e) => onInputChange(e)}
              value={name}
              class="col col-6"
            />

            <div className="col-6">
              <label>Select Restaurent</label>
              <select
                name="restro_id"
                required
                className="form-control"
                value={restro_id}
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="row">
            <Input
              id="facebook_url"
              label="Facebook Url"
              type="text"
              name="facebook_url"
              place="Facebook Url"
              onChange={(e) => onInputChange(e)}
              value={facebook_url}
              class="col col-6"
            />
            {/* <Input
              id="twitter_url"
              label="Twitter Url"
              type="text"
              name="twitter_url"
              place="Twitter Url"
              onChange={(e) => onInputChange(e)}
              value={twitter_url}
              class="col col-6"
            /> */}
            <Input
              id="instagram_url"
              label="Instagram Url"
              type="text"
              name="instagram_url"
              place="Instagram Url"
              onChange={(e) => onInputChange(e)}
              value={instagram_url}
              class="col col-6"
            />
          </div>
          <div className="row">
            <Input
              id="website_url"
              label="Website Url"
              type="text"
              name="website_url"
              place="Website Url"
              onChange={(e) => onInputChange(e)}
              value={website_url}
              class="col col-6"
            />
            <div className="col col-4">
              <label>Status</label>
              <select
                name="status"
                 requiredInput="required"
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={status}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>

            <Input
              id="sort"
              label="Sort No."
              type="text"
              name="sort"
              place="Sort No."
              onChange={(e) => onInputChange(e)}
              value={sort}
              class="col col-2"
            />
          </div>
          <div className="row py-3">
            <Input
              id="people_served"
              label="People Served"
              type="text"
              name="people_served"
              place="People Served"
              onChange={(e) => onInputChange(e)}
              value={people_served}
              class="col col-4"
            />
            <Input
              id="events_hosted"
              label="Events Hosted"
              type="text"
              name="events_hosted"
              place="Events Hosted"
              onChange={(e) => onInputChange(e)}
              value={events_hosted}
              class="col col-4"
            />
            <Input
              id="opened_in"
              label="Opened In"
              type="text"
              name="opened_in"
              place="Opened In"
              onChange={(e) => onInputChange(e)}
              value={opened_in}
              class="col col-4"
            />
          </div>
          <div className="row py-4">
            <TextAreaInput
              id="description"
              label="Description"
              name="description"
              place="Description"
              onChange={(e) => onInputChange(e)}
              value={description}
              class="col col-6"
            />
            <TextAreaInput
              id="address"
              label="Address"
              name="address"
              place="Address"
              onChange={(e) => onInputChange(e)}
              value={address}
              class="col col-6"
            />
          </div>

          <div className="row py-4">
            <Input
              id="title1"
              label="Title1"
              type="text"
              name="title1"
              place="Title1"
              onChange={(e) => onInputChange(e)}
              value={title1}
              class="col col-3"
            />
            <Input
              id="title2"
              label="Title2"
              type="text"
              name="title2"
              place="Title2"
              onChange={(e) => onInputChange(e)}
              value={title2}
              class="col col-3"
            />
            <Input
              id="title3"
              label="Title3"
              type="text"
              name="title3"
              place="Title3"
              onChange={(e) => onInputChange(e)}
              value={title3}
              class="col col-3"
            />
            <Input
              id="title4"
              label="Title4"
              type="text"
              name="title4"
              place="Title4"
              onChange={(e) => onInputChange(e)}
              value={title4}
              class="col col-3"
            />
          </div>

          <div className="row py-4">
            <Input
              id="subtitle1"
              label="Subtitle1"
              type="text"
              name="subtitle1"
              place="Subtitle1"
              onChange={(e) => onInputChange(e)}
              value={subtitle1}
              class="col col-3"
            />
            <Input
              id="subtitle2"
              label="Subtitle2"
              type="text"
              name="subtitle2"
              place="Subtitle2"
              onChange={(e) => onInputChange(e)}
              value={subtitle2}
              class="col col-3"
            />
            <Input
              id="subtitle3"
              label="Subtitle3"
              type="text"
              name="subtitle3"
              place="Subtitle3"
              onChange={(e) => onInputChange(e)}
              value={subtitle3}
              class="col col-3"
            />
            <Input
              id="subtitle4"
              label="Subtitle4"
              type="text"
              name="subtitle4"
              place="Subtitle1"
              onChange={(e) => onInputChange(e)}
              value={subtitle4}
              class="col col-3"
            />
          </div>
          <div className="row py-4">
            <div className="col col-3">
              <label>FeaturesIcon1 (For Web)</label>
              <p>Note: Icon Size Should be 84px x 84px </p>
              {featuresicon1 !==
              "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={featuresicon1}
                    height="100px"
                    width="100px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "featuresicon1")}
                  ></Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedfeaturesicon1(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
            <div className="col col-3">
              <label>FeaturesIcon2 (For Web)</label>
              <p>Note: Icon Size Should be 84px x 84px </p>
              {featuresicon2 !==
              "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={featuresicon2}
                    height="100px"
                    width="100px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "featuresicon2")}
                  ></Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedfeaturesicon2(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
            <div className="col col-3">
              <label>FeaturesIcon3 (For Web)</label>
              <p>Note: Icon Size Should be 84px x 84px </p>
              {featuresicon3 !==
              "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={featuresicon3}
                    height="100px"
                    width="100px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "featuresicon3")}
                  ></Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedfeaturesicon3(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
            <div className="col col-3">
              <label>FeaturesIcon4 (For Web)</label>
              <p>Note: Icon Size Should be 84px x 84px </p>
              {featuresicon4 !==
              "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={featuresicon4}
                    height="100px"
                    width="100px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "featuresicon4")}
                  ></Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedfeaturesicon4(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
          </div>
          <div className="row py-4">
            <div className="col col-4">
              <label>Home Image (For Web)</label>
              <p>
                Note: Image Size Should be <b>513 x 418px </b>
              </p>
              {image !== "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={image}
                    height="200px"
                    width="200px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "image")}
                  ></Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedFileImage(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
            <div className="col col-4">
              <label>Logo (For Web)</label>
              <p>
                Note: Image Size Should be <b>268 x 70px </b>
              </p>
              {logo !== "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={logo}
                    height="200px"
                    width="200px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "logo")}
                  >
                    {/* Delete */}
                  </Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedFile(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
            <div className="col col-4">
              <label>Banner Video (For Web)</label>
              <p>
                Note: Video Size Should be <b> 30mb</b>
              </p>
              {banner_video !==
              "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <video
                    style={{ width: "70%", height: "70%" }}
                    playsInline
                    loop
                    muted
                    autoPlay
                    alt="All the devices"
                    src={banner_video}
                  />
                  <Button
                    variant="outlined"
                    className="ml-5"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "banner_video")}
                  ></Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedwebVideo(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};
export default EditBrand;
